/* file description */

import React, { useEffect, useState } from 'react';
import { COLUMN_FROM, VALUE_TYPES } from './consts';
import { TransformNalmalType2TableColumn } from './type';
import { Input, InputNumber } from 'antd';
import _ from 'lodash';
import { useDebounceEffect } from 'ahooks';
import memo from '../component/memo';
import { FormFrom } from '@/components/SPForm';

const InputNumberMemo = memo(InputNumber);

/** 获取依赖项 */
function getDependencies(calculation: string): string[] {
  const res = (calculation || '').match(/\$[a-z_A-Z]+/g) || [];
  return res.map((key) => key.replace('$', ''));
}

/**
 * 表达式计算
 * @param express '$account * $price'
 * @param values any
 * @returns number
 */
function getCalculation(express: string, values: any) {
  const exp = express.replace(/\$/g, 'this.');
  const fun = new Function(`return ${exp}`).bind(values);
  let res = null;
  try {
    res = fun();
  } catch (e) {
    console.warn(e);
  }
  return res;
}

/**
 * 行序号组件
 */
function IndexInput({
  value,
  onChange,
  index,
  ...otherProps
}: {
  // 序号值
  value?: any;
  onChange?: (v: any) => void;
  /** 当前行序号 */
  index: number;
  [key: string]: any;
}) {
  // 延迟触发，因为添加行数据时，onChange的触发会在表单初始化之前执行，导致_id拿不到
  useDebounceEffect(() => {
    if (value !== index + 1) {
      onChange?.(index + 1);
    }
  }, [index], { wait: 50 });
  return <Input value={value} onChange={onChange} style={{ maxWidth: 80 }} {...otherProps} />;
}

// 失焦时触发onCHange
function InputNumberOfBlurChange({
  value,
  onChange,
  config,
  form,
  ...otherProps
}: any) {
  const [currentValue, setCurrentValue] = useState(value);
  const onBlur = () => {
    onChange(currentValue);
  };

  useEffect(() => {
    // if (_.isNumber(value) && _.isNumber(otherProps.precision)) {
    //   const precisionOfValue = _.toNumber(value.toFixed(otherProps.precision));
    //   if (value !== precisionOfValue) {
    //     if (config.from === FormFrom.Table) {
    //       form.setFieldValue(config.name, precisionOfValue);
    //     }
    //     return;
    //   }
    // }
    setCurrentValue(value);
  }, [value]);

  return <InputNumber value={currentValue} onChange={setCurrentValue} onBlur={onBlur} {...otherProps} />;
}

const IndexInputMemo = memo(IndexInput);

export const transformNumber2TableColumn: TransformNalmalType2TableColumn = ({
  targetColumn,
  field,
}) => {
  // field的key
  const fieldName = field?.name ?? '';
  // 前缀
  const prefix = field?.options?.prefix;
  const bizConfig = field?.bizConfig || {};

  // 后缀
  const suffix = field?.options?.suffix;
  targetColumn.valueType = VALUE_TYPES.DIGIT;
  targetColumn.fieldProps = {
    addonBefore: prefix,
    addonAfter: suffix,
    max: bizConfig.max,
    min: bizConfig.min,
    precision: bizConfig.precision,
  };

  targetColumn.renderFormItem = (schema, config, form) => {
    return <InputNumberOfBlurChange config={config} form={form} style={{ width: '100%' }} />;
  };

  // 展示态
  targetColumn.render = (dom, entity) => {
    // form时 entity[fieldName]也有值
    // const value = entity[fieldName] ?? entity?.value
    let value = entity?.value;
    // 精度处理
    if (value && _.isNumber(value) && _.isNumber(bizConfig.precision)) {
      value = value.toFixed(bizConfig.precision);
    }
    const isThSplit = field?.bizConfig?.isThSplit;
    // 千分位处理
    if (isThSplit && value) {
      const v = value.toString().split('.');
      value = `${Number(v[0]).toLocaleString()}${v[1] ? `.${v[1]}` : ''}`;
    }
    // const text = field.formatValue?.(value) || value;
    if (value) {
      return `${prefix || ''}${value}${suffix || ''}`;
    }
    return '-';
  };

  // 自定义计算表达式处理
  if (bizConfig.calculation) {
    const dependencies = getDependencies(bizConfig.calculation);
    targetColumn.dependencies = dependencies;
    targetColumn.renderFormItem = (schema, config, form) => {
      const values: Record<string, any> = {};
      dependencies.forEach((key) => {
        values[key] = form.getFieldValue(key);
      });
      const v = getCalculation(bizConfig.calculation, values);
      if (!Number.isNaN(v)) {
        form.setFieldValue(field.name, v);
      }
      return <InputNumberMemo style={{ width: '100%' }} title={bizConfig.calculation} />;
    };
  }

  // 该控件作为序号
  if (bizConfig.asIndex) {
    targetColumn.renderFormItem = (schema, config, form) => {
      return <IndexInputMemo index={config.rowIndex as number || 0} />;
    };

    // targetColumn.renderSearchItem = (schema, config, form) => {
    //   return <InputNumber />;
    // };
  }

  return targetColumn;
};
